<template>
    <b-row id="bottombar_component" class="bottombar-component">
        <b-col lg="3"></b-col>
        <b-col cols="12"
               lg="9"
               id="header_stats"
             class="header-stats">
            <header-stats></header-stats>
        </b-col>
    </b-row>
</template>

<script>
    import Calculating from './bottombar/Calculating.vue'
    import HeaderStats from './bottombar/HeaderStats.vue'
    import HeaderPayout from './bottombar/HeaderPayout.vue'

    export default {
        components: { Calculating, HeaderStats, HeaderPayout }
    }
</script>

<style lang="scss" scoped>
    .header-payout{
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        padding-bottom: 11px;
    }

    .bottombar-component{
        margin-bottom: 22px;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/header/Bottombar.vue